(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["WE-FAQ"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.faq-white-box').forEach(function (box) {
      if (box.dataset.faqInit === 'true') return;
      box.dataset.faqInit = 'true';

      box.querySelectorAll('.faq-question').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var item = btn.parentElement;
          var wasActive = item.classList.contains('active');

          box.querySelectorAll('.faq-item').forEach(function (el) {
            el.classList.remove('active');
            var q = el.querySelector('.faq-question');
            if (q) q.setAttribute('aria-expanded', 'false');
          });

          if (!wasActive) {
            item.classList.add('active');
            btn.setAttribute('aria-expanded', 'true');
          }
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["case-karrusel"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initAllCases() {
      document.querySelectorAll('.cases-section').forEach(function (section) {
        if (section.dataset.csInit === 'true') return;
        section.dataset.csInit = 'true';
        initSection(section);
      });
    }

    function initSection(section) {
      var track = section.querySelector('[data-cases-scroll]');
      var dotsWrap = section.querySelector('[data-cases-dots]');
      var prevBtn = section.querySelector('[data-cases-prev]');
      var nextBtn = section.querySelector('[data-cases-next]');
      if (!track) return;

      var cards = track.querySelectorAll('.case-card');

      function getStep() {
        var card = track.querySelector('.case-card');
        if (!card) return track.clientWidth;
        var styles = window.getComputedStyle(track);
        var gap = parseInt(styles.gap || styles.columnGap || 0, 10) || 0;
        return card.offsetWidth + gap;
      }

      function buildDots() {
        if (!dotsWrap) return;
        dotsWrap.innerHTML = '';
        if (cards.length <= 1) {
          dotsWrap.style.display = 'none';
          return;
        }
        dotsWrap.style.display = '';
        cards.forEach(function (_, i) {
          var d = document.createElement('button');
          d.type = 'button';
          d.className = 'car-dot' + (i === 0 ? ' active' : '');
          d.setAttribute('aria-label', 'Gå til case ' + (i + 1));
          d.addEventListener('click', function () {
            track.scrollTo({ left: getStep() * i, behavior: 'smooth' });
          });
          dotsWrap.appendChild(d);
        });
      }

      function updateDots() {
        if (!dotsWrap) return;
        var step = getStep();
        if (!step) return;
        var idx = Math.round(track.scrollLeft / step);
        dotsWrap.querySelectorAll('.car-dot').forEach(function (d, i) {
          d.classList.toggle('active', i === idx);
        });
      }

      function updateArrows() {
        if (!prevBtn || !nextBtn) return;
        var max = track.scrollWidth - track.clientWidth - 1;
        prevBtn.disabled = track.scrollLeft <= 0;
        nextBtn.disabled = track.scrollLeft >= max;
      }

      buildDots();
      updateDots();
      updateArrows();

      if (prevBtn) {
        prevBtn.addEventListener('click', function () {
          track.scrollBy({ left: -getStep(), behavior: 'smooth' });
        });
      }
      if (nextBtn) {
        nextBtn.addEventListener('click', function () {
          track.scrollBy({ left: getStep(), behavior: 'smooth' });
        });
      }

      var t;
      track.addEventListener('scroll', function () {
        clearTimeout(t);
        t = setTimeout(function () {
          updateDots();
          updateArrows();
        }, 80);
      }, { passive: true });

      var resizeT;
      window.addEventListener('resize', function () {
        clearTimeout(resizeT);
        resizeT = setTimeout(function () {
          updateDots();
          updateArrows();
        }, 150);
      });

      document.addEventListener('shopify:section:load', function (e) {
        if (section.contains(e.target)) {
          buildDots();
          updateDots();
          updateArrows();
        }
      });
      document.addEventListener('shopify:block:select', function (e) {
        if (section.contains(e.target)) {
          e.target.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
        }
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAllCases);
    } else {
      initAllCases();
    }
    document.addEventListener('shopify:section:load', initAllCases);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kundeudtalelser"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initTestimonials() {
      document.querySelectorAll('.testimonial-section').forEach(function (section) {
        if (section.dataset.tsInit === 'true') return;
        section.dataset.tsInit = 'true';
        initSection(section);
      });
    }

    function initSection(section) {
      var slides = section.querySelectorAll('.testimonial-slide');
      var dotsWrap = section.querySelector('[data-ts-dots]');
      if (!slides.length || !dotsWrap) return;

      var autoplay = section.dataset.autoplay === 'true';
      var interval = parseInt(section.dataset.interval, 10) || 5000;
      var current = 0;
      var timer = null;

      // Byg prikker (én pr. slide)
      dotsWrap.innerHTML = '';
      slides.forEach(function (_, i) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'dot' + (i === 0 ? ' active' : '');
        dot.setAttribute('aria-label', 'Vis udtalelse ' + (i + 1));
        dot.addEventListener('click', function () {
          showSlide(i);
          resetTimer();
        });
        dotsWrap.appendChild(dot);
      });

      var dots = dotsWrap.querySelectorAll('.dot');

      function showSlide(index) {
        slides.forEach(function (s) { s.classList.remove('active'); });
        dots.forEach(function (d) { d.classList.remove('active'); });
        slides[index].classList.add('active');
        if (dots[index]) dots[index].classList.add('active');
        current = index;
      }

      function nextSlide() {
        showSlide((current + 1) % slides.length);
      }

      function startTimer() {
        if (!autoplay || slides.length <= 1) return;
        timer = setInterval(nextSlide, interval);
      }

      function resetTimer() {
        if (timer) clearInterval(timer);
        startTimer();
      }

      // Pause autoplay ved hover
      section.addEventListener('mouseenter', function () {
        if (timer) clearInterval(timer);
      });
      section.addEventListener('mouseleave', startTimer);

      // Theme editor: spring til den blok brugeren har klikket på
      document.addEventListener('shopify:block:select', function (e) {
        if (section.contains(e.target)) {
          var idx = Array.prototype.indexOf.call(slides, e.target);
          if (idx >= 0) {
            showSlide(idx);
            if (timer) clearInterval(timer);
          }
        }
      });
      document.addEventListener('shopify:block:deselect', function (e) {
        if (section.contains(e.target)) startTimer();
      });

      startTimer();
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initTestimonials);
    } else {
      initTestimonials();
    }
    document.addEventListener('shopify:section:load', initTestimonials);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:navigate', (event) => {
    theme.settings.cartType !== 'page' && event.preventDefault();
  });

  document.addEventListener('product-form:submit:success', () => {
    document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["proceskarrusel"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initGuideCarousels() {
      document.querySelectorAll('.guide-section').forEach(function (section) {
        if (section.dataset.gcInit === 'true') return;
        section.dataset.gcInit = 'true';
        initSection(section);
      });
    }

    function initSection(section) {

      var container = section.querySelector('[data-guide-scroll]');
      var dotsWrap = section.querySelector('[data-guide-dots]');
      if (!container || !dotsWrap) return;

      function buildDots() {
        var totalScroll = container.scrollWidth - container.clientWidth;
        var steps = container.querySelectorAll('.guide-step').length;

        // Hvis intet scroll og kun få kort: vis ingen prikker
        if (totalScroll <= 1 || steps <= 1) {
          dotsWrap.innerHTML = '';
          dotsWrap.style.display = 'none';
          return;
        }
        dotsWrap.style.display = '';

        // 2 prikker på mobil-lignende visning, ellers ud fra hvor meget der scrolles
        var ratio = totalScroll / container.clientWidth;
        var pages = Math.min(5, Math.max(2, Math.round(ratio) + 1));

        dotsWrap.innerHTML = '';
        for (var i = 0; i < pages; i++) {
          var dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'dot' + (i === 0 ? ' active' : '');
          dot.setAttribute('aria-label', 'Gå til slide ' + (i + 1));
          (function (index) {
            dot.addEventListener('click', function () {
              var target = (totalScroll / (pages - 1)) * index;
              container.scrollTo({ left: target, behavior: 'smooth' });
            });
          })(i);
          dotsWrap.appendChild(dot);
        }
      }

      function updateActiveDot() {
        var dots = dotsWrap.querySelectorAll('.dot');
        if (!dots.length) return;
        var totalScroll = container.scrollWidth - container.clientWidth;
        if (totalScroll <= 0) return;
        var ratio = container.scrollLeft / totalScroll;
        var activeIndex = Math.round(ratio * (dots.length - 1));
        dots.forEach(function (d, i) {
          d.classList.toggle('active', i === activeIndex);
        });
      }

      buildDots();
      updateActiveDot();

      container.addEventListener('scroll', updateActiveDot, { passive: true });

      var resizeTimer;
      window.addEventListener('resize', function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function () {
          buildDots();
          updateActiveDot();
        }, 150);
      });

      // Reager på Shopifys theme editor-events
      document.addEventListener('shopify:section:load', function (e) {
        if (section.contains(e.target)) {
          buildDots();
          updateActiveDot();
        }
      });
      document.addEventListener('shopify:block:select', function (e) {
        if (section.contains(e.target)) {
          e.target.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
        }
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initGuideCarousels);
    } else {
      initGuideCarousels();
    }

    // Re-init når Shopify loader sektionen i theme editor
    document.addEventListener('shopify:section:load', initGuideCarousels);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sticky-mobile-cta"] && !Shopify.designMode) return;
  try {
    
  (function(){
    var bar = document.getElementById('StickyCTA');
    if(!bar) return;

    var contact = document.getElementById('kontakt') || document.getElementById('Kontakt');
    var lastY = window.pageYOffset;
    var threshold = 240; // px scroll before showing

    function update(){
      var y = window.pageYOffset;

      // Hide when contact section is in viewport
      if(contact){
        var rect = contact.getBoundingClientRect();
        var inView = rect.top < window.innerHeight * 0.85 && rect.bottom > 0;
        if(inView){
          bar.classList.remove('is-visible');
          bar.classList.add('is-hidden');
          lastY = y;
          return;
        }
      }

      // Show when scrolled past threshold
      if(y > threshold){
        bar.classList.add('is-visible');
        bar.classList.remove('is-hidden');
      } else {
        bar.classList.remove('is-visible');
      }
      lastY = y;
    }

    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  })();

  } catch(e) { console.error(e); }
})();
})();
